import { tns } from 'NM/tiny-slider/src/tiny-slider';

const Hero = () => {
  const body = document.querySelector('body');
  const homepageHero = document.querySelector('.hero--homepage');
  const collectiveHero = document.querySelector('.hero--collective');
  const breakpoint = body.getAttribute('data-breakpoint');
  const videoToggler = document.querySelectorAll('.background-video-toggle');
  let activeVideo = document.querySelector('.video-player');
  const scrollDown = document.querySelector('.scroll-down__link');
  const heroElem = document.querySelector('.hero');

  if (homepageHero) {
    const heroSlider = tns({
      container: '.carousel--hero',
      items: 1,
      slideBy: 'page',
      autoplay: true,
      controls: false,
      autoplayText: ['Play', 'Pause'],
      autoplayTimeout: 10000,
      onInit(info) {
        const slideItems = [...info.slideItems];
        tnsTabIndexOnInit(slideItems);
      },
    });

    heroSlider.events.on('indexChanged', info => {
      const slideItems = [...info.slideItems];
      tnsTabIndexOnInit(slideItems);
    });

    tnsStuff();
  }

  if (heroElem && document.querySelector('.hero') && scrollDown) {
    scrollDown.addEventListener('click', e => {
      e.preventDefault();
      const offsetTop = heroElem.nextElementSibling.offsetTop;

      scroll({
        top: offsetTop,
        behavior: 'smooth',
      });
    });
  }

  if (collectiveHero && breakpoint === 'mobile') {
    const carousel = document.querySelector('.carousel--hero-collective');

    if (carousel) {
      const collectiveSlider = tns({
        container: '.carousel--hero-collective',
        items: 1,
        slideBy: 'page',
        navPosition: 'bottom',
        autoplayPosition: 'bottom',
        controls: false,
        fixedWidth: 260,
        gutter: 20,
        loop: false,
        preventScrollOnTouch: 'force',
      });

      collectiveSlider.events.on('indexChanged', info => {
        if (info.displayIndex === 3) {
          carousel.parentNode.classList.add('carousel--hero-collective--no-fade');
        } else {
          carousel.parentNode.classList.remove('carousel--hero-collective--no-fade');
        }
      });
    }
  }

  videoToggler.forEach(toggler => {
    toggler.addEventListener('click', () => {
      if (homepageHero) {
        const activeSlide = document.querySelector('.tns-slide-active');
        activeVideo = activeSlide.querySelector('.video-player');
      }

      if (toggler.classList.contains('background-video-toggle--paused')) {
        toggler.classList.remove('background-video-toggle--paused');
        toggler.setAttribute('aria-label', 'Pause video');
        activeVideo.classList.remove('video-player--paused');
        activeVideo.play();
      } else {
        toggler.classList.add('background-video-toggle--paused');
        toggler.setAttribute('aria-label', 'Play video');
        activeVideo.classList.add('video-player--paused');
        activeVideo.pause();
      }
    });
  });

  function tnsStuff() {
    const slideControls = document.createElement('div');
    const tnsOuter = document.querySelector('.tns-outer');
    const tnsNav = document.querySelector('.tns-nav');
    const buttons = tnsNav.querySelectorAll('button');

    if (tnsOuter) {
      const tnsPause = tnsOuter.querySelector('button[data-action]');

      slideControls.classList.add('carousel-control');
      slideControls.appendChild(tnsPause);
      slideControls.appendChild(tnsNav);

      tnsOuter.prepend(slideControls);

      if (tnsPause) {
        tnsPause.addEventListener('click', function() {
          const state = this.getAttribute('data-action');

          if (state === 'start') {
            tnsNav.classList.add('tns-nav--paused');
          } else {
            tnsNav.classList.remove('tns-nav--paused');
          }
        });
      }

      // Workaround against plugin's built-in auto-pause when clicking
      // slide item controls
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          if (tnsPause.getAttribute('data-action') === 'stop') {
            setTimeout(() => tnsPause.click(), 1);
          }
        });
      });
    }
  }

  function tnsTabIndexOnInit(slideItems) {
    slideItems.forEach(item => {
      if (item.classList.contains('tns-slide-active')) {
        item.querySelector('.cta a').removeAttribute('tabindex');
        if (item.querySelector('.background-video-toggle')) {
          item.querySelector('.background-video-toggle').removeAttribute('tabindex');
        }
      } else {
        item.querySelector('.cta a').setAttribute('tabindex', '-1');
        if (item.querySelector('.background-video-toggle')) {
          item.querySelector('.background-video-toggle').setAttribute('tabindex', '-1');
        }
      }
    });
  }
};

jQuery(document).ready(function() {
	if(jQuery('#vertical-scroll-slideshow-list').length > 0) {
		var vert_slider = Object(NM_tiny_slider_src_tiny_slider__WEBPACK_IMPORTED_MODULE_0__["tns"])({
			container: '#vertical-scroll-slideshow-list',
			autoHeight: false,
			autoplay: false,
			autoplayButtonOutput: false,
			autoplayHoverPause: true,
			controls: false,
			items: 1,
			mode: 'fade',
			mouseDrag: true,
			navPosition: 'top',
			slideBy: 'page',
			speed: 400,
		});
		var module_top = jQuery('.vertical-scroll-container').offset().top;
		var slide_height = jQuery('.vertical-scroll-container').outerHeight();
		var slide_count = jQuery('.vertical-scroll-slideshow').data('slide-count');
		var slide_scroll_amount = (slide_height / slide_count);
		var slide_scroll_check = (module_top - (slide_height / slide_count));
		var has_scrolled = false;
		var current_item = 0;

		jQuery(document).scroll(function() {
			setTimeout(function() {
				var info = vert_slider.getInfo(),
				indexCurrent = info.index;
				if(jQuery(document).scrollTop() > (slide_scroll_check) & indexCurrent == current_item) {
					current_item = current_item + 1;
					vert_slider.goTo(current_item);
					has_scrolled = true;
					slide_scroll_check = slide_scroll_check + slide_scroll_amount;
				}
			},100);
		});
	}
	if(jQuery('.wysiwyg-slideshow-container').length > 0) {
		jQuery('.wysiwyg-slideshow-container').each(function() {
			var carousel_items = jQuery(this).data('slide-count');
			var carousel_container = jQuery(this).attr('id');
			var slider = Object(NM_tiny_slider_src_tiny_slider__WEBPACK_IMPORTED_MODULE_0__["tns"])({
				container: '#' + carousel_container,
				controlsPosition: 'bottom',
				nav: false,
				speed: 1600,
				autoplayHoverPause: true,
				controlsText: ["<span class=\"control-icon prev-icon\"></span>","<span class=\"control-icon next-icon\"></span>"],
				slideBy: 'page',
				autoplay: true,
				autoplayButtonOutput: false,
				items: 1,
				mouseDrag: true,
				autoHeight: false
			});
		});
	}
	if(jQuery('.card-carousel').length > 0) {
		jQuery('.card-carousel').each(function() {
			var carousel_items = jQuery(this).data('carousel-items');
			var carousel_container = jQuery(this).attr('id');
			var slider = Object(NM_tiny_slider_src_tiny_slider__WEBPACK_IMPORTED_MODULE_0__["tns"])({
				container: '#' + carousel_container,
				controlsPosition: 'bottom',
				navPosition: 'bottom',
				speed: 800,
				autoplayHoverPause: true,
				controlsText: ["<span class=\"control-icon prev-icon\"></span>","<span class=\"control-icon next-icon\"></span>"],
				slideBy: 'page',
				autoplay: true,
				autoplayButtonOutput: false,
				items: 1,
				responsive: {
					767: {
						items: 2
					},
					1024: {
						items: carousel_items
					}
				}
			});
		});
	}
  if(jQuery('.cast-carousel').length > 0) {
		jQuery('.cast-carousel').each(function() {
			var carousel_items = jQuery(this).data('carousel-items');
			var carousel_container = jQuery(this).attr('id');
			var slider = Object(NM_tiny_slider_src_tiny_slider__WEBPACK_IMPORTED_MODULE_0__["tns"])({
				container: '#' + carousel_container,
				controlsPosition: 'bottom',
				navPosition: 'bottom',
				speed: 800,
				autoplayHoverPause: true,
				controlsText: ["<span class=\"control-icon prev-icon\"></span>","<span class=\"control-icon next-icon\"></span>"],
				slideBy: 'page',
				autoplay: true,
				autoplayButtonOutput: false,
				items: 1,
				responsive: {
					767: {
						items: 3
					},
					1024: {
						items: carousel_items
					}
				}
			});
		});
  }
	card_title_height();
	hero_vimeo_background();
});

jQuery(window).resize(function() {
	setTimeout(function() {
		card_title_height();
	},2000);
	hero_vimeo_background();
});

function hero_vimeo_background() {
	if(jQuery('.hero__background .video-embed').length > 0) {
		jQuery('.hero__background .video-embed').each(function(v) {
			var video_height = jQuery(this).height();
			var video_width_original = jQuery(this).width();
			var video_width = video_height / .5625;

			if(video_width_original > video_width) {
				var video_width = video_width_original;
				var video_height = video_width * .5625;
			}

			jQuery(this).find('iframe').width(video_width);
			jQuery(this).find('iframe').height(video_height);
		});
	}
}

function card_title_height() {
	if(jQuery('.card-list').length > 0) {
		jQuery('.card-list').each(function(v) {
			var container = jQuery(this).attr('id');
   			var maxHeight = -1;
			jQuery('#' + container + ' .card__title').each(function() {
	     		jQuery(this).css('flex-basis', 'auto');
     			maxHeight = maxHeight > jQuery(this).height() ? maxHeight : jQuery(this).height();
			});
			jQuery('#' + container + ' .card__title').each(function() {
     			jQuery(this).css('flex-basis', maxHeight);
			});
		});
	}
}

export default Hero;
